import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import PrimaryEmailInput from '../../../Shared/PrimaryEmailInput/PrimaryEmailInput';
import DigitalSignature from '../Partials/DigitalSignature/DigitalSignature';
import { goToPage, setEmail, reportDWH, saveToHistory, setErrorText , setIsDisplayPopupForHelp,setIframeUrl} from '../energySaleBlockSlice';
import {createEnergySignatureFile, getEnergySignatureFileStatus} from '../energySaleBlockAsyncThunk';
import SignIcon from '../images/sign.svg';
import { gtag4 } from '../../../../utilities/analytics/tracking';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { debounce } from 'lodash';

const DigitalSignaturePage = (props) => {
  const [digitalSignatureEnable, setDigitalSignatureEnable] = useState(false);
  const [signatureUrl , setSignatureUrl] = useState(null);

  const debouncedHandleChange = useRef(null);

  //page params
  let btnText =  'לעדכון אמצעי תשלום';
  let currentPageFunction = handlePageContinue;
  const formid = 'energySaleBlock';
  const isDisplayFooter = true;
  //page params

  let title = props.epiText.title;
  let subTitle = props.iecResponse.serviceMigratable ? props.epiText.subTitleYesSmartMone : props.epiText.subTitleNoSmartMone ;
  let subTitleBold = 'מהי כתובת המייל לשליחת טופס ייפוי כוח?';

  useExtendedEffect((runSideEffects) => {
    gtag4({
      event: 'Energy_Step7_PoaPage',
      step: '7',
      action: 'PoaPage',
      funnel_name: props.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
    });
    props.reportDWH({ actionType: 'Power of Attorney', status: 'Ongoing', messageText: 'Power of Attorney - Display' })
    if (runSideEffects()) {
    }
  },
  [],);

  useEffect(() => {
    debouncedHandleChange.current = debounce((value) => {
      const isValid = emailValidate(value);
      if(isValid){
      createEnergySignatureFile();
      }
    }, 5000); // Adjust the delay as needed

    // Clean up the debounce function on unmount
    return () => {
      debouncedHandleChange.current.cancel();
    };
  }, []);

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <Image className='energy-sale-icon' src={SignIcon} />
      <h1 className='energy-sale-title' dangerouslySetInnerHTML={{__html: title}}></h1>
      <h2 className='energy-sale-sub-title' dangerouslySetInnerHTML={{__html: subTitle}}></h2>
      <h3 className='energy-sale-sub-title bold'> {subTitleBold} </h3>
    </div>
  );

  let currentPageView = (
    <>
      <PrimaryEmailInput isDisplayFooter={isDisplayFooter} email={props.email} setEmail={handleInputChange} errorText={''}/>
      <DigitalSignature isSignDigitalSignature={props.signatureInfo.isSigned} disable={!digitalSignatureEnable} link={signatureUrl} onClick={handleOnClickDigitalSignatureBtn}/>
    </>
  );

  return (
    <>
      <div className='energy-sale-content-wrapper'>
        {currentPageHeadline}
        <div className='energy-sale-page-content width-440'>
          <form noValidate id='sale' onSubmit={handleSubmit}>
            {currentPageView}
          </form>
        </div>
      </div>
      <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} error={props.errorText} formid={formid} />
    </>
  );


  function emailValidate(email) {
    if (!email) {
      props.setErrorText('אנא הכנס כתובת מייל');
      return false;
    }
    else{
      const isValid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
      if(isValid){
        props.setErrorText('');
        return true;
      }else{
        props.setErrorText('אנא הכנס כתובת מייל תקינה');
        return false;
      }
    }
  }


  function handleInputChange(email) {
      setDigitalSignatureEnable(false);
      props.setEmail(email);
      debouncedHandleChange.current(email);
      //props.saveToHistory();

  }


  async function handleOnClickDigitalSignatureBtn(e){
    gtag4({
      event: 'Energy_Step7_PoaSignature',
      step: '7',
      action: 'PoaSignature',
      funnel_name: props.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
    });
    props.reportDWH({ actionType: 'Power of Attorney', status: 'Ongoing', messageText: 'Power of Attorney - Open document Clicked' })
    props.setIframeUrl(signatureUrl)
    props.goToPage('signatureIframe');
  }

  async function createEnergySignatureFile(){
    const signatureFileResponse = await props.createEnergySignatureFile();
    if(signatureFileResponse.payload.isSuccess){
      const url = signatureFileResponse.payload.signUrl;
      setDigitalSignatureEnable(true);
      setSignatureUrl(url);
    }
  }

  function handlePageContinue() {
    const isValidEmail = emailValidate(props.email);
    if(isValidEmail){
      if (props.signatureInfo.isSigned) {
        gtag4({
          event: 'Energy_Step7_PoaUpdatePaymentMethod',
          step: '7',
          action: 'PoaUpdatePaymentMethod',
          funnel_name: props.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
        });
        props.reportDWH({ actionType: 'Power of Attorney', status: 'Ongoing', messageText: 'Power of Attorney - Clicked' })
        props.goToPage('paymentPage');
      }
      else{
        if(!props.signatureInfo.signUrl){
          props.setErrorText('כדי להמשיך יש לחתום על טופס ייפוי כוח');
        }
        else{
           props.getEnergySignatureFileStatus();
        }
      }
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

};

const mapStateToProps = (state) => {
  return {
    email : state.energySaleBlock.personalInfo.email,
    iecResponse : state.energySaleBlock.iecResponse,
    smartMeterPrice: state.energySaleBlock.energySaleBlockData.smartMeterPrice,
    signatureInfo : state.energySaleBlock.signatureInfo,
    errorText: state.energySaleBlock.errorText,
    isStartWithSelectedPackage: state.energySaleBlock.isStartWithSelectedPackage,
    epiText: state.energySaleBlock.energySaleBlockData.epiText.digitalSignaturePage,
  };
};

const mapDispatchToProps = {
  goToPage,
  setEmail,
  reportDWH,
  setErrorText,
  setIframeUrl,
  createEnergySignatureFile,
  getEnergySignatureFileStatus,
  saveToHistory,
  setIsDisplayPopupForHelp
};

export default connect(mapStateToProps, mapDispatchToProps)(DigitalSignaturePage);
